// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../services/bao-router";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-upload";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoDialog from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";

class ChecklistReminderTab {
    private _subs: KnockoutSubscription[] = [];
    constructor(tabPage: TabPage, parent: any) {
        this._subs.push(this.PageIndex.subscribe(() => {
            this.Refresh();
        }));
        this._subs.push(this.Sorting.subscribe(() => {
            this.Refresh();
        }));
        this._subs.push(this.SelectedRow.subscribe(() => {
            if (this.SelectedRow() == null) {
                this.enableDisableButton(this.PermissionEdit, false);
                this.enableDisableButton(this.PermissionDelete, false);
            }
            else {
                this.enableDisableButton(this.PermissionEdit, true);
                this.enableDisableButton(this.PermissionDelete, Bao.Utils.String.IsNullOrWhitespace(this.SelectedRow().CompleteDateJs));
            }
        }));
        this.TabPage = tabPage;
        this.Parent = parent;
        this.ParentKeyValue(this.Parent.PrimaryKeyValue());
        this.AdditionalFields.push({ Key: "CONFIGURATIONITEMID", Value: this.Parent.ConfigurationItemId() });
    }
    Bao = Bao;
    TabPage: TabPage;
    Parent: any;
    private _msgCancel = Bao.Session.GetMessage("msgCancel");
    private _msgOk = Bao.Session.GetMessage("msgOk");
    private _deleteMessage = Bao.Session.GetMessage("msgDeleteConfigurationItemEvaluation");
    private _urlCreate = "ChecklistReminderTab/Create";
    private _urlDelete = "ChecklistReminderTab/Delete";
    private _urlRefresh = "ChecklistReminderTab/Get";
    PermissionAdd = "AddReminderEvaluation";
    PermissionEdit = "EditReminderEvaluation";
    PermissionDelete = "DeleteReminderEvaluation";
    PermissionRefresh = "RefreshReminderEvaluation";
    PageIndex = ko.observable(0);
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    Sorting = ko.observableArray();
    EvaluationCollection = ko.observableArray([]);
    SelectedRow = ko.observable<any>();
    ParentKeyValue = ko.observable(); //TODO: Wert hier reinbekommen
    AdditionalFields = [];
    SelectRow = (item) => {
        this.SelectedRow(item);
        return true;
    };
    CompleteCheck() {
        return true;
    }
    toolbarClick = (action) => {
        switch (action.ActionKey()) {
            case this.PermissionAdd:
                this.ShowCreateEvaluationDialog();
                break;
            case this.PermissionEdit:
                if (this.SelectedRow() != null) {
                    this.EditEvaluation(this.SelectedRow());
                }
                break;
            case this.PermissionDelete:
                var yesNoDialog = new baoDialog(Bao.Session.ApplicationName, this._deleteMessage, "yesno");
                yesNoDialog.DialogResult.subscribe((result) => {
                    if (result === true) {
                        this.DeleteEvaluation(this.SelectedRow());
                    }
                });
                break;
            case this.PermissionRefresh:
                this.Refresh();
                break;
        }
    };
    Refresh() {
        this.TabPage.IsLoading(true);
        return Bao.post(this._urlRefresh, JSON.stringify({
            parentId: this.ParentKeyValue(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        }), (searchResult) => {
            this.TabPage.IsLoading(false);
            this.SelectedRow(null);
            this.TotalRows(0);
            this.EvaluationCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                this.EvaluationCollection(searchResult.Models);
                this.TotalRows(searchResult.TotalRows);
            }
        });
    }
    ;
    CreateEvaluation(folderStructureChecklistId) {
        this.TabPage.IsLoading(true);
        return Bao.post(this._urlCreate, JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            parentId: this.ParentKeyValue(),
            additionalFields: this.AdditionalFields
        }), (result) => {
            if (result != false) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
            this.TabPage.IsLoading(false);
        });
    }
    ;
    DeleteEvaluation(item) {
        Bao.post(this._urlDelete, JSON.stringify({
            parentId: this.ParentKeyValue(),
            evaluationId: ko.unwrap(item.EvaluationId)
        }), () => {
            this.Refresh();
        });
    }
    ;
    EditEvaluation(item) {
        baoRouter.setHash("checkware/evaluation/" + ko.unwrap(item.EvaluationId));
    }
    ;
    ShowCreateEvaluationDialog() {
        window.baorequire(['ViewModels/Dialogs/CreateEvaluationDialog'], (vm) => {
            var dialog = new vm(this.TabPage, self);
            dialog.Show();
            dialog.DialogResult.subscribe((dialogResult) => {
                if (dialogResult == true) {
                    this.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId());
                }
            });
        });
    }
    ;
    enableDisableButton(actionKey, enabled) {
        //Dummy
    }
    ;
    Save() {
        //Tab Interface - no functionality
    }
    ;
    init() {
        let def = $.Deferred();
        def.resolve();
        return def.promise();
    }
    loaded() {
        return this.Refresh();
    }
    ;
}
export default ChecklistReminderTab;